import { useQuery } from 'react-query';

import * as RestApi from 'core/network/RestApi';
import { BulkRetargetingCampaign } from 'models/offsite/Campaign/BulkRetargetingCampaign';
import { generatePath } from 'react-router';
import { BulkRetargetingCampaignEndpoints } from '../constants';

export interface GetBulkRetargetingQueryRequest {
  siteId: string;
  campaignId: string;
}

export const getBulkRetargetingQuery = async ({ siteId, campaignId }: GetBulkRetargetingQueryRequest) => {
  const result = await RestApi.get<BulkRetargetingCampaign>(
    generatePath(BulkRetargetingCampaignEndpoints.GET, {
      siteId,
      campaignId,
    }),
  );

  return result.data;
};

export const useGetBulkRetargetingCampaignQuery = (payload: GetBulkRetargetingQueryRequest) => {
  const query = useQuery(['bulk-retargeting-campaign', payload.siteId, payload.campaignId], {
    queryFn: () => getBulkRetargetingQuery(payload),
  });

  return query;
};
